/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React from 'react';
import _ from 'lodash';

// ours
import { FieldControl, Label, RadioButton, RadioGroup } from '@americanexpress/dls-react';

interface BWRadioGroupProps {
    label: string;
    name?: string;
    radioOptions: RadioOption[];
    onChange: (e: any) => void;
    defaultChecked?: string;
}

interface RadioOption {
    id: string;
    value: string;
    label: string;
    disabled?: boolean;
}

export default function BWRadioGroup(props: BWRadioGroupProps): JSX.Element {
    return (
        <FieldControl className="drawerSection">
            <Label>{props.label}</Label>
            <RadioGroup
                name={props.name}
                defaultChecked={props.defaultChecked}
                onChange={props.onChange}
                theme={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', gap: '24px' }}
            >
                {_.map(props.radioOptions, (option) => {
                    return (
                        <RadioButton
                            id={option.id}
                            value={option.value}
                            label={option.label}
                            theme={{ marginBottom: '0 !important' }}
                            disabled={option.disabled}
                        />
                    );
                })}
            </RadioGroup>
        </FieldControl>
    );
}
